module.exports = __webpack_public_path__ + "img/futuria.a65065c6.webp";